import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface EntidadContext {
  id: number;
  entidadId: string;
  codigoEntidadExternoId?: number;
  slug?: string;
}

@Injectable({ providedIn: 'root' })
export class EntidadContextService {
  private _current = new BehaviorSubject<EntidadContext | null>(null);
  readonly current$ = this._current.asObservable();

  set(entity: EntidadContext | null): void {
    this._current.next(entity);
  }

  getCurrent(): EntidadContext | null {
    return this._current.value;
  }
}
